"use strict";

var _classCallCheck = require("/home/im/impactminer/imfrontend/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/im/impactminer/imfrontend/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var types_1 = require("./types");

var Inner =
/*#__PURE__*/
function () {
  function Inner(snapshotOrDocument, sequentialIds) {
    _classCallCheck(this, Inner);

    this.sequentialIds = sequentialIds;

    if (snapshotOrDocument.commandCount != undefined && snapshotOrDocument.document != undefined) {
      this.snapshot = snapshotOrDocument;
    } else {
      this.snapshot = {
        commandCount: 0,
        document: snapshotOrDocument
      };
    }
  }

  _createClass(Inner, [{
    key: "getCommandCount",
    value: function getCommandCount() {
      return this.snapshot.commandCount;
    }
  }, {
    key: "getDocument",
    value: function getDocument() {
      return this.snapshot.document;
    }
  }, {
    key: "apply",
    value: function apply(command, proposeCreateId) {
      var path = command.path || [];

      switch (command.action) {
        case types_1.CommandAction.Create:
          {
            var result = this.navigateToNode(path);
            var node;
            var errorPath;

            if (result.found) {
              node = result.node;
            } else if (command.parentDefault && path.length > 0) {
              var parentsParent = this.navigateToNode(path.slice(0, path.length - 1));

              if (parentsParent.found) {
                parentsParent.node[path[path.length - 1]] = JSON.parse(JSON.stringify(command.parentDefault));
                node = parentsParent.node[path[path.length - 1]];
              } else {
                errorPath = parentsParent.errorPath;
              }
            } else {
              errorPath = result.errorPath;
            }

            if (node) {
              var attempt = 0;
              var newId;

              do {
                newId = proposeCreateId !== undefined && attempt === 0 ? proposeCreateId : this.generateNewId(attempt);
                attempt += 1;
              } while (newId in node);

              node[newId] = command.props != undefined ? JSON.parse(JSON.stringify(command.props)) : {};
              this.snapshot.commandCount += 1;
              return {
                isSuccess: true,
                createdId: newId
              };
            }

            return {
              isSuccess: false,
              error: 'No object at document path ' + (errorPath || []).toString()
            };
          }

        case types_1.CommandAction.Update:
          {
            var _result = this.navigateToNode(path);

            if (_result.found) {
              var propKeys = command.props !== undefined ? Object.keys(command.props) : [];

              if (propKeys.length > 0) {
                var copy = JSON.parse(JSON.stringify(command.props));
                propKeys.forEach(function (key) {
                  _result.node[key] = copy[key];
                });
              }

              this.snapshot.commandCount += 1;
              return {
                isSuccess: true
              };
            }

            return {
              isSuccess: false,
              error: 'No object at document path ' + _result.errorPath.toString()
            };
          }

        case types_1.CommandAction.Delete:
          {
            var _result2 = this.navigateToNode(path.slice(0, path.length - 1));

            if (_result2.found) {
              delete _result2.node[path[path.length - 1]];
              this.snapshot.commandCount += 1;
              return {
                isSuccess: true
              };
            }

            return {
              isSuccess: false,
              error: 'No object at document path ' + _result2.errorPath.toString()
            };
          }

        default:
          {
            // never supposed to end up here
            console.log('Unknown action in command ' + JSON.stringify(command));
            return {
              isSuccess: false,
              error: 'Unknown command'
            };
          }
      }
    }
  }, {
    key: "navigateToNode",
    value: function navigateToNode(path) {
      var n = this.snapshot.document;

      for (var i = 0; i < path.length; i++) {
        n = n[path[i]];

        if (typeof n !== 'object') {
          return {
            found: false,
            errorPath: path.slice(0, i + 1)
          };
        }
      }

      return {
        found: true,
        node: n
      };
    }
  }, {
    key: "generateNewId",
    value: function generateNewId(attempt) {
      if (this.sequentialIds) {
        return (this.snapshot.commandCount + 1 + attempt).toString();
      } else {
        return Math.round(Math.random() * Number.MAX_SAFE_INTEGER).toString();
      }
    }
  }]);

  return Inner;
}();

exports.Inner = Inner;